import "./footer.css";
import packageJson from "../../../package.json";
import "bootstrap-icons/font/bootstrap-icons.css";
import imgLogo from "../../Assets/images/logo_connectserasa_branco.png";
import imgLogoSafeWeb from "../../Assets/images/logo-Safeweb-branco.png";
import imgLogoOnline from "../../Assets/images/logo-Online-branco.png";
// /logo_connectserasa_branco.png'

function Footer({ contexto }) {
  const currentDate = new Date().getFullYear();
  const facebook =
    contexto.facebook && contexto.facebook !== ""
      ? contexto.facebook
      : "https://www.facebook.com/connectsaoficial/";
  const instagram =
    contexto.instagram && contexto.instagram !== ""
      ? contexto.instagram
      : "https://www.instagram.com/connectsaoficial/";
  const linkedin =
    contexto.linkedin && contexto.linkedin !== ""
      ? contexto.linkedin
      : "https://www.linkedin.com/company/connectsaoficial";
  let linkSejaConnect = [];
  for (let i = 0; i <= 12; i++) {
    if (contexto.linkSejaConnect && i === 10) {
      linkSejaConnect.push("" + contexto.linkSejaConnect);
    } else {
      linkSejaConnect.push("https://www.connectsa.com.br/solucoes-connect/");
    }
  }

  return (
    <div>
      <div className="footer">
        <div className="container">
          <div className="row desktop-footer">
            <div className="col-md-4">
              <div className="col-md-12 text-footer">
                <div className="img-footer">
                  <img src={imgLogo} alt="rodape-img" />
                </div>
                <p>
                  A Connect é Distribuidor Autorizado Serasa Experian, oferece
                  soluções nas áreas de informações de crédito e cadastro e
                  monitoramento de documentos de pessoas jurídicas para
                  prevenção de fraudes.
                </p>
              </div>
              <div className="btn-saibamais">
                <a href="http://www.connectsa.com.br/" target="_blank">
                  Saiba mais
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div className="col-md-12 text-footer">
                <div className="img-footer">
                  <img src={imgLogoSafeWeb} alt="rodape-img" />
                </div>
                <p>
                  Informações digitais seguras e confiáveis. <br></br>
                  Somos a SafeWeb a 2ª Maior emissora de Certificados Digitais
                  do Brasil
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="col-md-12 text-footer">
                <div className="img-footer">
                  <img src={imgLogoOnline} alt="rodape-img" />
                </div>
                <p>
                  Certificados Digitais e soluções comerciais para cada etapa do
                  seu negócio. Fique Online e conte com a gente para levar sua
                  empresa cada vez mais longe
                </p>
              </div>
            </div>
            {/* <div className="col-md-8">
              <div className="row">
                <div className="col-md-4 list-footer">
                  <ul>
                    <li>
                      <a href={linkSejaConnect[1]} target="_blank">
                        Consultas de Crédito e Cadastro
                      </a>
                    </li>
                    <li>
                      <a href={linkSejaConnect[2]} target="_blank">
                        Recuperação de Dívidas
                      </a>
                    </li>
                    <li>
                      <a href={linkSejaConnect[3]} target="_blank">
                        Consultas Veículo
                      </a>
                    </li>
                    <li>
                      <a href={linkSejaConnect[4]} target="_blank">
                        Me Proteja
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 list-footer">
                  <ul>
                    <li>
                      <a href={linkSejaConnect[5]} target="_blank">
                        Maquininha de Cartão
                      </a>
                    </li>
                    <li>
                      <a href={linkSejaConnect[6]} target="_blank">
                        Negocie Legal
                      </a>
                    </li>
                    <li>
                      <a href={linkSejaConnect[7]} target="_blank">
                        Controle Legal
                      </a>
                    </li>
                    <li>
                      <a href={linkSejaConnect[8]} target="_blank">
                        Cartão Private Label
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 list-footer">
                  <ul>
                    <li>
                      <a href={linkSejaConnect[9]} target="_blank">
                        2ª Via de Boleto
                      </a>
                    </li>
                    <li>
                      <a href={linkSejaConnect[10]} target="_blank">
                        Seja Connect
                      </a>
                    </li>
                    <li>
                      <a href={linkSejaConnect[11]} target="_blank">
                        Atendimento ao Cliente
                      </a>
                    </li>
                    <li>
                      <a href={linkSejaConnect[12]} target="_blank">
                        Acesso ao Sistema Connect
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
          <div className="row text-center copyright">
            <p>® {currentDate} Connect - Todos os direitos reservados </p>
            <p>
              Desenvolvido por <span className="label-connect">Connect SA</span>
              <br />
              {packageJson.version}
            </p>
            <h4 className="font-icons">
              <a className="icon-footer" href={`${facebook}`} target="_blank">
                <i className="bi bi-facebook"></i>
              </a>
              <a className="icon-footer" href={`${instagram}`} target="_blank">
                <i className="bi bi-instagram"></i>
              </a>
              <a className="icon-footer" href={`${linkedin}`} target="_blank">
                <i className="bi bi-linkedin"></i>
              </a>
            </h4>{" "}
          </div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
